import { render } from "./ReadingTimer.vue?vue&type=template&id=66d0bc26&scoped=true"
import script from "./ReadingTimer.vue?vue&type=script&lang=js"
export * from "./ReadingTimer.vue?vue&type=script&lang=js"

import "./ReadingTimer.vue?vue&type=style&index=0&id=66d0bc26&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66d0bc26"]])

export default __exports__